import { css } from "@emotion/react";
import { motion } from "framer-motion";
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";
import { useIsDesktopMediaQuery } from "../../../hooks/useIsDesktopMediaQuery";
import { useProductBrowserState } from "../../../hooks/useProductBrowserState";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import type { FwQueryResponse } from "../../../lib/FwReact/FwQuery";
import { ProductDetailsPopup } from "../../ProductDetails/ProductDetails";
import { ProductBrowserGridItem } from "./ProductBrowserGridItem";

export type ProductBrowserGridProps = {
	products: ImmutableObject<FwQueryResponse<Product>>;
};
export const ProductBrowserGrid: React.FC<ProductBrowserGridProps> = (
	props,
) => {
	const productDetailsState = useProductDetailsState();
	const products = props.products;
	const productBrowserState = useProductBrowserState();
	const isDesktop = useIsDesktopMediaQuery();
	let itemWidth = productBrowserState.get().itemWidth;
	if (!isDesktop) {
		itemWidth = 185;
	}

	return (
		<>
			<div
				css={css`
				background: var(--product-browser-well-background);
                display: grid;
                justify-items: center;
                gap: 1px 1px;
                @media (min-width: 720px) {
                    gap: 1em 1em;
                }`}
				style={{
					gridTemplateColumns: `repeat(auto-fill, minmax(${itemWidth}px, 1fr))`,
					padding: isDesktop ? "1em" : "0",
				}}
			>
				{products.Items.map((product) => (
					<motion.div
						css={css`
                        flex: 1 1 0;
                        width:100%;
                        box-sizing: border-box;
                        display:flex;
                        flex-direction:column;
                    `}
						key={product.Id}
						layoutId={product.Id}
						transition={{ type: "spring", stiffness: 180, damping: 26 }}
					>
						<ProductBrowserGridItem product={product} />
					</motion.div>
				))}
			</div>

			<ProductDetailsPopup
				layoutId={productDetailsState.get().product?.Id ?? "0"}
			/>
		</>
	);
};
